import React, { useState, useEffect, forwardRef, useMemo } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  ButtonGroup,
} from "@material-ui/core";
import t from "../CommonComponents/localization";
import { useSelector } from "react-redux";
import moment from "moment";
import { getAccessType, getAvailableModes } from "../../utils/accessType";
import { splitDeviceAndVehicleIds } from "../../utils/reportVehicleUtils";
import { LocksAction } from "../../actions/lock";
import "./indec.css";
import ExportReport from "../CommonComponents/Export";
import { Grid, Paper, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AddressAction } from "../../actions/Address";
import Typography from "@material-ui/core/Typography";
import { useLocation } from "react-router-dom";
import { SiteAction } from "../../actions/site";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Styles } from "../Reports/style";
import { VehicleAction } from "../../actions/vehicle";
import { VendorAction } from "../../actions/vendor";
import ExportPdf from "../CommonComponents/exportPdf";
import { Report } from "@material-ui/icons";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, createFilterOptions, Typography as MuiTypography } from "@mui/material";
import { DailyDistanceReportData } from "../../actions/DailyDistanceReportAction";
import CommonHierarchicalTable from "../CommonComponents/CommonHierarchicalTable";
import LoadingComponent from "../CommonComponents/loadinComponent";
import { FaFilePdf } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa6";
import SendIcon from "@mui/icons-material/Send";
import {
  Autocomplete as MuiAutocomplete,
  Chip,
  TextField as MuiTextField,
  Paper as MuiPaper,
  Fade,
} from "@mui/material";
import { FixedSizeList } from "react-window";
import { styled, keyframes } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";

import { BsFileEarmarkPdfFill } from "react-icons/bs";
import DownloadIcon from "@mui/icons-material/Download";

import { useToast } from "../CommonComponents/useToast";

import GpsBlue from "../../assets/ais_new_images/GPS Blue.svg";
import GpsWhite from "../../assets/ais_new_images/GPS white.svg";
import LockBlue from "../../assets/ais_new_images/Lock blue.svg";
import LockWhite from "../../assets/ais_new_images/Lock White.svg";
// ─── Status config ────────────────────────────────────────────────────────────
const statusColors = {
  RUNNING: { color: "#2e7d32", bg: "#2e7d321a", label: "Running", icon: "●" },
  STOP: { color: "#d32f2f", bg: "#d32f2f1a", label: "Stop", icon: "●" },
  IDLE: { color: "#ed6c02", bg: "#ed6c021a", label: "Idle", icon: "●" },
  OFFLINE: { color: "#0288d1", bg: "#0288d11a", label: "Offline", icon: "●" },
};
const lockStatusColors = {
  ENGAGED: { color: "#2e7d32", bg: "#2e7d321a", label: "Engaged", icon: "🔒" },
  IDLE: { color: "#6b7280", bg: "#6b72801a", label: "Disengaged", icon: "🔓" },
};

const getLockStatusCfg = (option) => {
  const status = (option?.status || (option?.isEngaged ? "ENGAGED" : "IDLE")).toUpperCase();
  return lockStatusColors[status] || lockStatusColors.IDLE;
};

// ─── Animations ───────────────────────────────────────────────────────────────
const pulseAnimation = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50%       { transform: scale(1.2); opacity: 0.8; }
`;
const slideInAnimation = keyframes`
  from { opacity: 0; transform: translateX(-20px); }
  to   { opacity: 1; transform: translateX(0); }
`;

// ─── Styled components ────────────────────────────────────────────────────────
const StatusIndicator = styled("span")(({ status }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: statusColors[status]?.color || statusColors.OFFLINE.color,
  marginRight: 10,
  flexShrink: 0,
  animation:
    status === "RUNNING" ? `${pulseAnimation} 2s ease-in-out infinite` : "none",
  boxShadow: `0 0 6px ${statusColors[status]?.color || statusColors.OFFLINE.color}`,
}));

//======================================NIKHIL CHANGES STARTS=======================================
const OptionWrapper = styled(Box)(({ index }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "100%",
  padding: "6px 12px",
  boxSizing: "border-box",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateX(4px)",
    backgroundColor: "rgba(0,0,0,0.02)",
  },
}));
//============================NIKHIL CHANGES ENDS=====================================================
const LegendContainer = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: 4,
  padding: 6,
  backgroundColor: "hsl(210, 40%, 98%)",
  borderBottom: "1px solid hsl(214.3, 31.8%, 91.4%)",
});

const LegendItem = styled(Chip, {
  shouldForwardProp: (p) => p !== "statuscolor" && p !== "isSelected" && p !== "colorMap",
})(({ statuscolor, isSelected, colorMap }) => {
  const map = colorMap || statusColors;
  const base = map[statuscolor].color;
  const bg = map[statuscolor].bg;
  return {
    height: 26,
    fontSize: 10,
    fontWeight: 600,
    borderRadius: 13,
    border: `1px solid ${base}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: isSelected ? base : bg,
    color: isSelected ? "#fff" : base,
    "& .MuiChip-icon": {
      color: isSelected ? "#fff" : base,
      margin: 0,
      marginLeft: 6,
    },
    "& .MuiChip-label": { marginRight: 6, paddingRight: 10 },
    "& .MuiChip-deleteIcon": {
      color: isSelected ? "#fff" : base,
      marginLeft: "-4px",
      marginRight: "4px",
      fontSize: "14px",
      "&:hover": {
        color: isSelected ? "#f3f4f6" : `${base}cc`,
      },
    },
    "&:hover": {
      backgroundColor: isSelected ? base : `${base}20`,
      color: isSelected ? "#fff" : base,
      transform: "scale(1.04)",
      boxShadow: `0 2px 8px ${base}40`,
    },
    "&.Mui-focusVisible": { boxShadow: "none" },
  };
});

const StatusBadge = styled("span")(({ status }) => ({
  fontSize: 9,
  fontWeight: 700,
  padding: "1px 6px",
  borderRadius: 10,
  backgroundColor: statusColors[status]?.bg,
  color: statusColors[status]?.color,
  marginLeft: "auto",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

function InfoMessage() {
  return (
    <Box
      display="inline-flex"
      alignItems="flex-start"
      gap={1}
      px={1.5}
      py={0.75}
      border={1}
      borderRadius={1}
      // borderColor="info.main"
      borderColor="#082D6B"
    // bgcolor="warning.light"
    >
      <InfoOutlinedIcon
        fontSize="small"
        // color="info"
        color="#082D6B"
        sx={{ mt: "2px", flexShrink: 0 }}
      />

      <MuiTypography
        variant="body2"
        // color="info.main"
        color="#082D6B"
        sx={{ lineHeight: 1.6, fontSize: 13 }}
      >
        Date range is limited to{" "}
        <MuiTypography component="span" fontWeight={600} color="#082D6B">
          1 month
        </MuiTypography>
        .
      </MuiTypography>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    padding: theme.spacing(1),
    // maxWidth:"14%"
  },
}));
// ─── Stoppage Vehicle Autocomplete constants ─────────────────────
//===================================NIKHIL CHANGES STARTS HERE=========================================================
const STP_ROW_HEIGHT = 44;
const GET_MAX_STOPPAGE_VEHICLE_SELECT = (reportType) => {
  try {
    const raw = localStorage.getItem("dailywiseDeviceLimit");
    if (raw) {
      const parsed = JSON.parse(raw);
      let key = "reportsMaximumDevicesToExport";

      switch (reportType) {
        case "stop":
          key = "maxVehiclesForStopReport";
          break;
        case "idle":
          key = "maxVehiclesForIdleReport";
          break;
        case "summary":
        case "dailyDistance":
          key = "maxVehiclesForDistanceSummary";
          break;
        case "trip":
          key = "maxVehiclesForTripReport";
          break;
        case "travel":
          key = "maxVehiclesForTravelSummary";
          break;
        default:
          key = "reportsMaximumDevicesToExport";
      }

      const limit = parseInt(parsed[key], 10);
      if (!isNaN(limit) && limit > 0) return limit;

      // Fallback to general limit
      const generalLimit = parseInt(parsed?.reportsMaximumDevicesToExport, 10);
      if (!isNaN(generalLimit) && generalLimit > 0) return generalLimit;
    }
  } catch (_) { }
  return 30;
};

const GET_REPORTS_STARTING_DATE = () => {
  try {
    const raw = localStorage.getItem("dailywiseDeviceLimit");
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.reportsStartingDate) {
        // Format from DD-MM-YYYY to a moment object
        return moment(parsed.reportsStartingDate, "DD-MM-YYYY").startOf("day");
      }
    }
  } catch (_) { }
  return null;
};

const StpListboxComponent = forwardRef(
  function StpListboxComponent(props, ref) {
    const { children, ...other } = props;
    const items = React.Children.toArray(children);
    return (
      <div ref={ref} {...other}>
        <FixedSizeList
          height={Math.min(items.length * STP_ROW_HEIGHT, 300)}
          itemCount={items.length}
          itemSize={STP_ROW_HEIGHT}
          width="100%"
          overscanCount={5}
        >
          {({ index, style }) => React.cloneElement(items[index], { style })}
        </FixedSizeList>
      </div>
    );
  },
);

const StpVehiclePaper = forwardRef(function StpVehiclePaper(props, ref) {
  const {
    children,
    stpVehicleFilterType,
    setStpVehicleFilterType,
    MAX_STOPPAGE_VEHICLE_SELECT,
    isToDateToday,
    trackingMode,
    ...rest
  } = props;
  const isLockMode = trackingMode === "digitalLock";
  const entityLabel = isLockMode ? "locks" : "vehicles";

  return (
    <Fade in timeout={200}>
      <MuiPaper
        ref={ref}
        {...rest}
        sx={{
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          border: "1px solid #e5e7eb",
          overflow: "hidden",
          "& .MuiAutocomplete-listbox": {
            padding: "4px 0",
            maxHeight: "none",
            overflow: "hidden",
          },
        }}
      >
        {!isLockMode && (
          <LegendContainer
            onMouseDown={(e) => e.preventDefault()}
            onClick={(e) => e.stopPropagation()}
          >
            {Object.entries(statusColors).map(([key, val]) => (
              <LegendItem
                key={key}
                statuscolor={key}
                isSelected={key === stpVehicleFilterType}
                icon={
                  <span style={{ fontSize: 12, marginBottom: "1px" }}>
                    {val.icon}
                  </span>
                }
                label={val.label}
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setStpVehicleFilterType((prev) => (prev === key ? "" : key));
                }}
                onDelete={
                  key === stpVehicleFilterType
                    ? (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setStpVehicleFilterType("");
                    }
                    : undefined
                }
              />
            ))}
          </LegendContainer>
        )}
        {children}
        {isToDateToday ? (
          <div
            style={{
              padding: "8px 12px",
              fontSize: 11,
              fontWeight: 600,
              color: "#92400e",
              borderTop: "1px solid #fde68a",
              backgroundColor: "#fffbeb",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
            }}
          >
            <span style={{ fontSize: 13 }}>⚠️</span>
            Maximum {MAX_STOPPAGE_VEHICLE_SELECT} {entityLabel} allowed for today's date
          </div>
        ) : (
          <div
            style={{
              padding: "6px 12px",
              fontSize: 11,
              color: "#6b7280",
              borderTop: "1px solid #f3f4f6",
              backgroundColor: "#f9fafb",
              textAlign: "center",
            }}
          >
            You can select up to {MAX_STOPPAGE_VEHICLE_SELECT} {entityLabel}
          </div>
        )}
      </MuiPaper>
    </Fade>
  );
});

const OldReportRequestDialog = ({
  row,
  onClose,
  reportsMinDate,
  stoppageVehicleList,
  MAX_STOPPAGE_VEHICLE_SELECT,
  reportType,
  report,
  trackingMode,
}) => {
  const toast = useToast();
  const [oldFrom, setOldFrom] = useState(null);
  const [oldTo, setOldTo] = useState(null);
  const [selectedVehicles, setSelectedVehicles] = useState(
    stoppageVehicleList || [],
  );
  const [selectedStoppageVehicles, setSelectedStoppageVehicles] = useState([]);
  const [stpVehicleFilterType, setStpVehicleFilterType] = useState("");
  const [stoppageSortSelectedIds, setStoppageSortSelectedIds] = useState(
    new Set(),
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState("");

  const resetForm = () => {
    setOldFrom(null);
    setOldTo(null);
    setSelectedStoppageVehicles([]);
    setStpVehicleFilterType("");
    setStoppageSortSelectedIds(new Set());
    setEmail("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
  const emailValid = email.length > 0 && isValidEmail(email);
  const emailInvalid = email.length > 0 && !isValidEmail(email);

  const filteredStoppageVehicleList = useMemo(() => {
    if (!stpVehicleFilterType) return stoppageVehicleList;
    return stoppageVehicleList.filter(
      (v) =>
        v.runningStatus?.toUpperCase() === stpVehicleFilterType ||
        selectedStoppageVehicles.some((sv) => sv.id === v.id),
    );
  }, [stoppageVehicleList, stpVehicleFilterType, selectedStoppageVehicles]);

  const sortedStoppageVehicleList = useMemo(() => {
    return [...filteredStoppageVehicleList].sort((a, b) => {
      const aSel = stoppageSortSelectedIds.has(a.id);
      const bSel = stoppageSortSelectedIds.has(b.id);

      // 1. Snapshot-selected vehicles first
      if (aSel && !bSel) return -1;
      if (!aSel && bSel) return 1;

      // 2. If status is cleared (or even if not, for intra-group sorting), Running status vehicles come on top
      if (!stpVehicleFilterType) {
        const aRunning = a.runningStatus?.toUpperCase() === "RUNNING";
        const bRunning = b.runningStatus?.toUpperCase() === "RUNNING";
        if (aRunning && !bRunning) return -1;
        if (!aRunning && bRunning) return 1;
      }

      return 0;
    });
  }, [
    filteredStoppageVehicleList,
    stoppageSortSelectedIds,
    stpVehicleFilterType,
  ]);

  const { deviceIds: selectedStoppageDeviceIds, vehicleIds: selectedStoppageVehicleEntityIds } = useMemo(
    () => splitDeviceAndVehicleIds(selectedStoppageVehicles),
    [selectedStoppageVehicles],
  );

  const effectiveReport = reportType || report;
  const rpn = effectiveReport.toUpperCase();
  const isViewPage = rpn === "DAILYDISTANCE" || rpn === "SUMMARY";
  let pageParam = "";
  if (rpn === "STOP" || rpn === "STOPREPORT" || rpn === "STOPPAGE")
    pageParam = "STOPPAGE_REPORT";
  else if (rpn === "IDLE" || rpn === "IDLEREPORT")
    pageParam = "IDLE_REPORT";
  else if (rpn === "DAILYDISTANCE") pageParam = "SUMMARY_REPORT";
  else if (
    rpn === "TRAVEL SUMMARY" ||
    rpn === "TRAVELSUMMARY" ||
    rpn === "SUMMARY"
  )
    pageParam = "SUMMARY_REPORT";
  else if (rpn === "TRIP" || rpn === "TRIPREPORT") pageParam = "TRIP_REPORT";
  else pageParam = rpn;

  const handleReleaseOldReportsData = async () => {
    if (!oldFrom || !oldTo) {
      toast.error("Please select a date range");
      return;
    }
    if (selectedStoppageVehicles.length === 0) {
      toast.error("Please select at least one vehicle");
      return;
    }
    if (!emailValid) {
      toast.error("Please enter a valid email address");
      return;
    }
    // const rpn = reportType.toUpperCase();
    // const isViewPage = rpn === "DAILYDISTANCE" || rpn === "SUMMARY";

    try {
      setIsSubmitting(true);
      const userId = JSON.parse(localStorage.getItem("data")).id;

      const payload = {
        deviceIds: selectedStoppageDeviceIds,
        ...(selectedStoppageVehicleEntityIds.length > 0
          ? { vehicleIds: selectedStoppageVehicleEntityIds }
          : {}),
        fromDate: oldFrom.valueOf(),
        toDate: oldTo.valueOf(),
        reportPageName: pageParam,
        userId: userId,
        email: email,
        isViewPage: isViewPage,
      };
      const response = await VendorAction.getOldReportData(payload);
      if (response) {
        toast.success("Success", "Request Raised Successfully");
        // onClose();
        handleClose();
      } else {
        toast.error("Error", "Failed to raise request");
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Error", "Failed to raise request");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Dialog
      open={Boolean(row)}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 20,
          overflow: "hidden",
          boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
        },
      }}
    >
      <div
        style={{
          background: "#082D6B",
          padding: "14px 18px",
          display: "flex",
          alignItems: "center",
          gap: 14,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-40%",
            right: "-5%",
            width: 200,
            height: 200,
            background:
              "radial-gradient(circle, rgba(255,255,255,0.07) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 3,
            }}
          >
            <span
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: "#fff",
                letterSpacing: 0.3,
              }}
            >
              Request Old Report data
            </span>
          </div>
        </div>

        {/* Close button */}
        <button
          onClick={handleClose}
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            flexShrink: 0,
            background: "rgba(239,68,68,0.15)",
            border: "1px solid rgba(239,68,68,0.35)",
            color: "#f87171",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
            fontWeight: 700,
            transition: "background 0.15s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "rgba(239,68,68,0.30)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "rgba(239,68,68,0.15)")
          }
        >
          ✕
        </button>
      </div>

      <div style={{ height: 3, background: "#ef4444", opacity: 0.85 }} />
      <DialogContent style={{ padding: "20px 24px", background: "#f0f4ff" }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <MuiTextField
              fullWidth
              size="small"
              type="date"
              variant="outlined"
              value={oldFrom ? oldFrom.format("YYYY-MM-DD") : ""}
              inputProps={{
                max: reportsMinDate
                  ? reportsMinDate.format("YYYY-MM-DD")
                  : undefined,
              }}
              onChange={(e) => {
                const newDate = moment(e.target.value).startOf("day");
                setOldFrom(newDate);
                if (oldTo && newDate.isAfter(oldTo)) setOldTo(null);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  minHeight: "40px",
                  borderRadius: "10px",
                  bgcolor: "#fff",
                  fontSize: 13,
                  "& fieldset": { borderColor: "#d1d5db" },
                  "&:hover fieldset": { borderColor: "#9ca3af" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#2563eb",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8px 12px",
                  fontSize: 13,
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MuiTextField
              fullWidth
              size="small"
              type="date"
              variant="outlined"
              value={oldTo ? oldTo.format("YYYY-MM-DD") : ""}
              inputProps={{
                min: oldFrom ? oldFrom.format("YYYY-MM-DD") : undefined,
                max: reportsMinDate
                  ? reportsMinDate.format("YYYY-MM-DD")
                  : undefined,
              }}
              onChange={(e) => {
                const newDate = moment(e.target.value).endOf("day");
                if (oldFrom && newDate.isBefore(oldFrom)) return;
                setOldTo(newDate);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  minHeight: "40px",
                  borderRadius: "10px",
                  bgcolor: "#fff",
                  fontSize: 13,
                  "& fieldset": { borderColor: "#d1d5db" },
                  "&:hover fieldset": { borderColor: "#9ca3af" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#2563eb",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8px 12px",
                  fontSize: 13,
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MuiAutocomplete
              multiple
              size="small"
              disableCloseOnSelect
              limitTags={1}
              options={sortedStoppageVehicleList}
              value={selectedStoppageVehicles}
              isOptionEqualToValue={(o, v) => o.id === v.id}
              getOptionLabel={(o) => o.number || ""}
              onOpen={() => {
                setStoppageSortSelectedIds(
                  new Set(selectedStoppageVehicles.map((v) => v.id)),
                );
              }}
              getOptionDisabled={(o) =>
                !selectedStoppageVehicles.some((s) => s.id === o.id) &&
                selectedStoppageVehicles.length >= MAX_STOPPAGE_VEHICLE_SELECT
              }
              filterOptions={
                trackingMode === "digitalLock" ? lockFilterOptions : vehicleFilterOptions
              }
              onChange={(_, newVal) =>
                setSelectedStoppageVehicles(
                  newVal.slice(0, MAX_STOPPAGE_VEHICLE_SELECT),
                )
              }
              ListboxComponent={StpListboxComponent}
              ListboxProps={{
                style: {
                  padding: 0,
                  maxHeight: "none",
                  overflow: "hidden",
                },
              }}
              PaperComponent={useMemo(
                () =>
                  forwardRef((props, ref) => (
                    <StpVehiclePaper
                      {...props}
                      ref={ref}
                      stpVehicleFilterType={stpVehicleFilterType}
                      setStpVehicleFilterType={setStpVehicleFilterType}
                      MAX_STOPPAGE_VEHICLE_SELECT={MAX_STOPPAGE_VEHICLE_SELECT}
                      trackingMode={trackingMode}

                    />
                  )),
                [
                  stpVehicleFilterType,
                  setStpVehicleFilterType,
                  MAX_STOPPAGE_VEHICLE_SELECT,
                  trackingMode
                ],
              )}
              renderTags={(tagVal, getTagProps) =>
                tagVal.length === 1 ? (
                  <Chip
                    label={tagVal[0].number}
                    size="small"
                    {...getTagProps({ index: 0 })}
                    sx={{ maxWidth: 90, fontSize: 11 }}
                  />
                ) : (
                  <span style={{ fontSize: 12, color: "#374151" }}>
                    {tagVal.length} vehicles
                  </span>
                )
              }
              renderOption={(props, option, { index }) => {

                const status =
                  option?.runningStatus?.toUpperCase() || "OFFLINE";
                const cfg = statusColors[status] || statusColors.OFFLINE;
                const isSelected = selectedStoppageVehicles.some(
                  (s) => s.id === option.id,
                );
                return (
                  <li
                    {...props}
                    style={{
                      ...props.style,
                      padding: 0,
                      margin: 0,
                      listStyle: "none",
                      height: STP_ROW_HEIGHT,
                    }}
                  >
                    <OptionWrapper
                      index={index}
                      sx={{
                        "&:hover": { backgroundColor: cfg.bg },
                        backgroundColor: isSelected
                          ? `${cfg.bg}80`
                          : "transparent",
                      }}
                    >
                      <input
                        type="checkbox"
                        readOnly
                        checked={isSelected}
                        style={{
                          accentColor: cfg.color,
                          width: 14,
                          height: 14,
                          marginRight: 10,
                          cursor: "pointer",
                        }}
                      />
                      <StatusIndicator status={status} />
                      <Box
                        component="span"
                        sx={{
                          flex: 1,
                          fontWeight: isSelected ? 600 : 500,
                          color: "hsl(222.2,84%,4.9%)",
                          fontSize: 13,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {option.number}
                      </Box>
                      <StatusBadge status={status}>{cfg.label}</StatusBadge>
                    </OptionWrapper>

                  </li>
                );
              }}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <MuiTextField
                  {...params}
                  variant="outlined"
                  placeholder={
                    trackingMode === "digitalLock"
                      ? "Select Lock"
                      : "Choose Vehicles"
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      minHeight: "40px",
                      borderRadius: "10px",
                      bgcolor: "#fff",
                      padding: "4px 8px !important",
                      fontSize: 13,
                      "& fieldset": { borderColor: "#d1d5db" },
                      "&:hover fieldset": { borderColor: "#9ca3af" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#2563eb",
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "0 4px !important",
                      fontSize: 13,
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <MuiTextField
              fullWidth
              size="small"
              type="email"
              variant="outlined"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  minHeight: "40px",
                  borderRadius: "10px",
                  bgcolor: "#fff",
                  fontSize: 13,
                  "& fieldset": {
                    borderColor: emailValid
                      ? "#2e7d32"
                      : emailInvalid
                        ? "#d32f2f"
                        : "#d1d5db",
                  },
                  "&:hover fieldset": {
                    borderColor: emailValid
                      ? "#2e7d32"
                      : emailInvalid
                        ? "#d32f2f"
                        : "#9ca3af",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: emailValid
                      ? "#2e7d32"
                      : emailInvalid
                        ? "#d32f2f"
                        : "#2563eb",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8px 12px",
                  fontSize: 13,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "12px 20px",
          background: "#f0f4ff",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <Button
          color="primary"
          variant="contained"
          // startIcon={<SendIcon />}
          startIcon={
            isSubmitting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <SendIcon />
            )
          }
          style={{
            borderRadius: 10,
            height: 36,
            minWidth: 80,
            background: "#082D6B",
          }}
          onClick={handleReleaseOldReportsData}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const vehicleFilterOptions = createFilterOptions({
  stringify: (option) => `${option.number || ""} ${option.imeiNo || ""}`,
});


const lockFilterOptions = createFilterOptions({
  stringify: (option) => `${option.number || ""} ${option.vehicleNo || ""}`,
});


const ModeToggle = ({ value, onChange, options }) => {
  const activeIndex = Math.max(
    0,
    options.findIndex((o) => o.value === value),
  );

  return (
    <div
      role="tablist"
      style={{
        position: "relative",
        display: "grid",
        gridTemplateColumns: `repeat(${options.length}, 1fr)`,
        background: "#e2e8f0",
        borderRadius: 10,
        padding: 3,
        marginRight: 10,
      }}
    >
      {/* Sliding selected pill */}
      <div
        style={{
          position: "absolute",
          top: 3,
          bottom: 3,
          left: 3,
          width: `calc((100% - 6px) / ${options.length})`,
          transform: `translateX(${activeIndex * 100}%)`,
          background: "#082D6B",
          borderRadius: 8,
          boxShadow: "0 2px 6px rgba(8,45,107,0.35)",
          transition: "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      />

      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            style={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              padding: "6px 16px",
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 700,
              whiteSpace: "nowrap",
              color: active ? "#fff" : "#475569",
              transition: "color 0.2s ease",
            }}
          >
            <img
              src={active ? opt.iconActive : opt.iconInactive}
              alt=""
              style={{ width: 18, height: 18, objectFit: "contain" }}
            />
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

//=================================================NIKHIL CHANGES ENDS HERE=============================================
const ReportFilter = ({
  children,
  handleSubmit,
  showOnly,
  setReportType,
  reportType,
  exportData,
  labelHeader,
  extraActions,
  onTrackingModeChange,
}) => {
  console.log(exportData);

  let exportPdf = exportData;
  let exportPdfHeader = labelHeader;

  let objExport = {};

  labelHeader.forEach((element, index) => {
    objExport[`col${index + 1}`] = element;
  });

  if (exportData.length > 0) {
    exportData = [objExport].concat(exportData);
  }

  const search = useLocation().search;

  const accessType = getAccessType();
  const availableModes = getAvailableModes(accessType); // e.g. ["gps"], ["digitalLock"], or ["gps","digitalLock"]

  const hasFixedLockPermission = (() => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      return data?.hasFixedLockPermission === true;
    } catch {
      return false;
    }
  })();

  // digitalLock is only usable if BOTH accessType allows it AND the permission flag is true
  const effectiveModes = availableModes.filter(
    (mode) => mode !== "digitalLock" || hasFixedLockPermission
  );

  // safety fallback: never end up with zero modes
  const finalModes = effectiveModes.length > 0 ? effectiveModes : ["gps"];

  const showToggle = finalModes.length > 1 && (window.location.pathname !== "/fuelSummaryReport" && window.location.pathname !== "/fuelFillReport" && window.location.pathname !== "/fuelDroppageReport");
  const [trackingMode, setTrackingMode] = useState(finalModes[0]);

  const [stoppageLockList, setStoppageLockList] = useState([]);

  const classes = useStyles();
  const devices = useState([]);
  const [deviceId, setDeviceId] = useState();
  const [period, setPeriod] = useState("today");
  const [report, setReport] = useState("stop");
  console.log("reportdue", report);
  useEffect(() => {
    if (reportType) setReport(reportType);
  }, [reportType]);
  const [reportTitle, setReportTitle] = useState("");
  const [selected, setSelected] = useState();
  const [from, setFrom] = useState(moment().startOf("day"));
  const [to, setTo] = useState(moment().endOf("day"));
  const [vehicleList, setVehicleList] = useState([]);
  const [siteList, setSiteList] = React.useState([]);
  const [vendorList, setVendorList] = React.useState([]);
  const [vendorId, setVendorId] = useState({});
  const [sourceId, setSourceId] = useState({});
  const [vehicleListOld, setVehicleListOld] = React.useState([]);
  const [routeId, setRouteId] = useState({});
  const [routeIdParent, setRouteIdParent] = useState({});
  // stoppage hierarchical report rows
  const [stoppageReportRows, setStoppageReportRows] = useState([]);
  const [stoppagePage, setStoppagePage] = useState(0);
  const [stoppageRowsPerPage, setStoppageRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [oldReport, setOldReport] = useState(false);
  //=======================================================NIKHIL CHANGES STARTS =========================================
  const MAX_STOPPAGE_VEHICLE_SELECT = useMemo(
    () => GET_MAX_STOPPAGE_VEHICLE_SELECT(report),
    [report],
  );

  const isToDateToday = useMemo(() => {
    const today = moment().startOf("day");
    return (
      moment(from).isSame(today, "day") && moment(to).isSame(today, "day")
    );
  }, [from, to]);

  const effectiveMaxVehicles = useMemo(() => {
    if (isToDateToday) {
      return 5;
    }
    return MAX_STOPPAGE_VEHICLE_SELECT;
  }, [isToDateToday, MAX_STOPPAGE_VEHICLE_SELECT]);

  useEffect(() => {
    if (selectedStoppageVehicles.length > effectiveMaxVehicles) {
      setSelectedStoppageVehicles((prev) =>
        prev.slice(0, effectiveMaxVehicles),
      );
    }
  }, [effectiveMaxVehicles]);


  //========================================================NIKHIL CHANGES ENDS=====================================
  const reportsMinDate = useMemo(() => GET_REPORTS_STARTING_DATE(), []);
  const reportsMinDateFormatted = useMemo(
    () =>
      reportsMinDate
        ? reportsMinDate.format(moment.HTML5_FMT.DATETIME_LOCAL)
        : "",
    [reportsMinDate],
  );
  // stoppage multi-select vehicles
  const [stoppageVehicleList, setStoppageVehicleList] = useState([]);
  const [selectedStoppageVehicles, setSelectedStoppageVehicles] = useState([]);
  const [stpVehicleFilterType, setStpVehicleFilterType] = useState("");

  useEffect(() => {
    setSelectedStoppageVehicles([]);
    setStoppageSortSelectedIds(new Set());
    setStpVehicleFilterType("");
    if (onTrackingModeChange) {
      onTrackingModeChange(trackingMode);
    }
  }, [trackingMode]);

  //=======================================================NIKHIL CHANGES STARTS =========================================

  const [stoppageSortSelectedIds, setStoppageSortSelectedIds] = useState(
    new Set(),
  );
  //========================================================NIKHIL CHANGES ENDS=====================================

  const activeDeviceList = trackingMode === "digitalLock" ? stoppageLockList : stoppageVehicleList;

  const { deviceIds: selectedStoppageVehicleIds, vehicleIds: selectedStoppageVehicleEntityIds } = useMemo(
    () => splitDeviceAndVehicleIds(selectedStoppageVehicles),
    [selectedStoppageVehicles],
  );

  const filteredStoppageVehicleList = useMemo(() => {
    if (!stpVehicleFilterType) return activeDeviceList;
    return activeDeviceList.filter(
      (v) =>
        v.runningStatus?.toUpperCase() === stpVehicleFilterType ||
        selectedStoppageVehicles.some((sv) => sv.id === v.id),
    );
  }, [activeDeviceList, stpVehicleFilterType, selectedStoppageVehicles]);

  //===================================NIKHIL CHANGES STARTS HERE=========================================================

  const sortedStoppageVehicleList = useMemo(() => {
    return [...filteredStoppageVehicleList].sort((a, b) => {
      const aSel = stoppageSortSelectedIds.has(a.id);
      const bSel = stoppageSortSelectedIds.has(b.id);

      // 1. Snapshot-selected vehicles first
      if (aSel && !bSel) return -1;
      if (!aSel && bSel) return 1;

      // 2. If status is cleared (or even if not, for intra-group sorting), Running status vehicles come on top
      if (!stpVehicleFilterType) {
        const aRunning = a.runningStatus?.toUpperCase() === "RUNNING";
        const bRunning = b.runningStatus?.toUpperCase() === "RUNNING";
        if (aRunning && !bRunning) return -1;
        if (!aRunning && bRunning) return 1;
      }

      return 0;
    });
  }, [
    filteredStoppageVehicleList,
    stoppageSortSelectedIds,
    stpVehicleFilterType,
  ]);
  //=================================================NIKHIL CHANGES ENDS HERE=============================================

  const datePresetOptions = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This Week", value: "thisWeek" },
    { label: "Last Week", value: "lastWeek" },
    { label: "This Month", value: "thisMonth" },
    { label: "Last Month", value: "lastMonth" },
  ];
  const [datePreset, setDatePreset] = useState(datePresetOptions[0]);

  const handleDatePresetChange = (option) => {
    setDatePreset(option);

    let selectedFrom;
    let selectedTo;

    switch (option.value) {
      case "today":
        selectedFrom = moment().startOf("day");
        selectedTo = moment().endOf("day");
        break;

      case "yesterday":
        selectedFrom = moment().subtract(1, "day").startOf("day");
        selectedTo = moment().subtract(1, "day").endOf("day");
        break;

      case "thisWeek":
        selectedFrom = moment().startOf("week"); // Sunday
        // selectedTo = moment().subtract(1, "day").endOf("day"); // yesterday
        selectedTo = moment().endOf("day");
        break;

      case "lastWeek":
        selectedFrom = moment().subtract(1, "week").startOf("week");
        selectedTo = moment().subtract(1, "week").endOf("week");
        break;

      case "thisMonth":
        selectedFrom = moment().startOf("month"); // 1st
        // selectedTo = moment().subtract(1, "day").endOf("day"); // yesterday
        selectedTo = moment().endOf("day");
        break;

      case "lastMonth":
        selectedFrom = moment().subtract(1, "month").startOf("month");
        selectedTo = moment().subtract(1, "month").endOf("month");
        break;

      default:
        return;
    }

    if (reportsMinDate && selectedFrom.isBefore(reportsMinDate)) {
      selectedFrom = reportsMinDate.clone();
    }

    // ✅ ADD THIS: If clamping pushed selectedFrom past selectedTo, clamp selectedTo too
    if (selectedTo.isBefore(selectedFrom)) {
      selectedTo = selectedFrom.clone().endOf("day");
    }

    setFrom(selectedFrom);
    setTo(selectedTo);
  };
  const [exportHeading, setExportHeading] = useState([
    `${window.location.pathname.split("/")[1] == "reportsgps"
      ? report
      : window.location.pathname.split("/")[1]
    } Report `,
    "From",
    `${document.getElementById("datetime-local") &&
    document.getElementById("datetime-local").value
    }`,
    "To",
    `${document.getElementById("datetime-local") &&
    document.getElementById("datetime-local").value
    }`,
  ]);

  const newReport = (e) => {
    console.log(e);
    setReport(e);
    setReportType(e);
    localStorage.setItem("Report", e);
  };

  // const newVehicle = (e) => {
  //   setDeviceId(e);
  //   localStorage.setItem("vehicle", JSON.stringify(e));
  // };

  setTimeout(() => {
    if (localStorage.getItem("Report")) {
      setReport(localStorage.getItem("Report"));
    }
  }, 1000);

  /** Convert milliseconds → "Xhr Ymin" (e.g. "17hr 23min") */
  function formatMsDuration(ms) {
    if (!ms && ms !== 0) return "—";
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    if (h === 0) return `${m}min`;
    return `${h}hr ${m}min`;
  }

  // ─── Stoppage Vehicle Autocomplete helpers (moved outside) ───────────

  const speedArray = Array.from({ length: 30 }, (_, i) => ({
    id: 51 + i,
    name: `${51 + i}`,
  }));

  useEffect(() => {
    const checkReport = localStorage.getItem("Report");
    if (checkReport) {
      setTimeout(() => {
        debugger;
        if (localStorage.getItem("Report")) {
          setReport(localStorage.getItem("Report"));
          // localStorage.removeItem('Report')
        }
        // if(localStorage.getItem('vehicle')){
        //   setDeviceId(JSON.parse(localStorage.getItem('vehicle')))
        // }
        let xy =
          window.location.pathname.split("/")[1] == "reportsgps"
            ? report + " Report"
            : window.location.pathname.split("/")[1] + " Report";
        setReportTitle(xy);
      }, 200);
    }
  }, []);

  useEffect(() => {
    console.log(new URLSearchParams(search).get("type"));
    const type = new URLSearchParams(search).get("type");
    if (type) {
      newReport(new URLSearchParams(search).get("type"));
    }
    // fetchVehicleList();
    fetchSiteList();
    fetchVendorList();
  }, []);

  const fetchSiteList = () => {
    debugger;
    SiteAction.fetchSiteList({
      pageNo: 0,
      pageSize: "",
      companyId: JSON.parse(localStorage.getItem("data")).companyId,
      showSubSite: "false",
    }).then((response) => {
      if (response != null) {
        console.log(response);
        setSiteList(response);
      } else {
        setSiteList([]);
      }
    });
  };

  const fetchVendorList = () => {
    debugger;
    let sideIds = [];
    if (
      JSON.parse(localStorage.getItem("data")).sites &&
      JSON.parse(localStorage.getItem("data")).sites.length > 0
    ) {
      JSON.parse(localStorage.getItem("data")).sites.forEach((element) => {
        sideIds.push(element.id);
      });
    }
    VendorAction.fetchVendorList({
      pageNo: 0,
      pageSize: "",
      companyId: JSON.parse(localStorage.getItem("data")).companyId,
      companyName: "",
      isActive: "",
      name: "",
      siteIds: sideIds,
      userId: JSON.parse(localStorage.getItem("data")).id,
    }).then((response) => {
      if (response != null) {
        setVendorList(response);
      } else {
        setVendorList([]);
      }
    });
  };

  const fetchVehicleList = async (term) => {
    let sideIds = [];
    if (
      JSON.parse(localStorage.getItem("data")).sites &&
      JSON.parse(localStorage.getItem("data")).sites.length > 0
    ) {
      JSON.parse(localStorage.getItem("data")).sites.forEach((element) => {
        sideIds.push(element.id);
      });
    }

    const res = await VehicleAction.fetchVehicleList({
      pageNo: 0,
      pageSize: 0,
      companyId: JSON.parse(localStorage.getItem("data")).companyId,
      number: term,
      vehicleType: "",
      driver: "",
      // vendorId: "",
      siteIds: sideIds,
      userId: JSON.parse(localStorage.getItem("data")).id,
      allVehicle: true,
      forDropDown: true,
    }).then((response) => {
      if (response != null && response.length > 0) {
        console.log(response);
        setVehicleList(response);
        setVehicleListOld(response);
      } else {
        setVehicleList([]);
      }
    });
  };

  function searchVehicle(getData, delay) {
    // debugger
    const that = this;
    let timer;
    return (...agrs) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        getData.apply(that, agrs);
      }, delay);
    };
  }

  const debouncedFunction = searchVehicle(fetchVehicleList, 1000);

  const fetchStoppageVehicleList = () => {
    const d = JSON.parse(localStorage.getItem("data"));
    const sideIds = (d.sites || []).map((s) => s.id);

    VehicleAction.fetchVehicleListV6({
      pageNo: 0,
      pageSize: 0,
      companyId: d.companyId,
      number: "",
      vehicleType: "",
      driver: "",
      siteId: "",
      siteIds: sideIds,
      userId: d.id,
      onlyGpsVehicle: true,
      forDropDown: "true",
    })
      .then((r) => {
        const list = Array.isArray(r) ? r : r?.data || [];
        // const withGps = list.filter(
        //   (v) => v?.gpsRefId != null && v.gpsRefId !== "",
        // );
        // console.log("withGps", withGps)
        // setStoppageVehicleList(withGps);
        setStoppageVehicleList(list);
      })
      .catch((err) => {
        console.error("fetchStoppageVehicleList error:", err);
        setStoppageVehicleList([]);
      });
  };

  const fetchStoppageLockList = async () => {
    try {
      const res = await LocksAction.getFixedLockList();
      if (res && res.data && Array.isArray(res.data)) {
        const mapped = res.data.map(lock => ({
          ...lock,
          number: lock.lockNumber || lock.number,
          gpsRefId: lock.gpsRefId || lock.id,
          vehicleNo: lock.number || null

        }));
        setStoppageLockList(mapped);
      } else if (res && Array.isArray(res)) {
        const mapped = res.map(lock => ({
          ...lock,
          number: lock.lockNumber || lock.number,
          gpsRefId: lock.gpsRefId || lock.id,
          vehicleNo: lock.number || null
        }));
        setStoppageLockList(mapped);
      }
    } catch (e) {
      console.log("Error fetching fixed locks for report:", e);
    }
  };

  useEffect(() => {
    fetchStoppageVehicleList();
    fetchStoppageLockList();
  }, []);
  function selectedDeviceHandler(data) {
    debugger;
    if (data) {
      setDeviceId(data);
      // setVehicleId(data);
      setSelected(data);
    } else {
      setDeviceId();
      // setVehicleId();
      setSelected();
    }
    // setAlreadyMappedVehicleOld((pre) => {
    //   console.log([...pre, ...data]);
    //   return [...pre, ...data];
    // });
    // data.forEach((ele) => {
    //   existingObj[ele.id] = ele;
    // });

    console.log(data);
  }
  const setDateToFrom = (period) => {
    debugger;
    setPeriod(period);
    let selectedFrom;
    let selectedTo;
    switch (period) {
      case "today":
        selectedFrom = moment().startOf("day");
        selectedTo = moment().endOf("day");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "yesterday":
        selectedFrom = moment().subtract(1, "day").startOf("day");
        selectedTo = moment().subtract(1, "day").endOf("day");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "thisWeek":
        selectedFrom = moment().startOf("week");
        selectedTo = moment().endOf("week");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "previousWeek":
        selectedFrom = moment().subtract(1, "week").startOf("week");
        selectedTo = moment().subtract(1, "week").endOf("week");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "thisMonth":
        selectedFrom = moment().startOf("month");
        selectedTo = moment().endOf("month");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "previousMonth":
        selectedFrom = moment().subtract(1, "month").startOf("month");
        selectedTo = moment().subtract(1, "month").endOf("month");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      default:
        selectedFrom = from;
        selectedTo = to;
        break;
    }
  };

  const handleClick = (mail, json) => {
    let exportHeadings = [
      `${window.location.pathname.split("/")[1] == "reportsgps"
        ? report
        : window.location.pathname.split("/")[1]
      } Report `,
      "From",
      `${document.getElementById("datetime-local") &&
      moment(document.getElementById("datetime-local").value).format(
        // report === "dailyDistance" || report === "summary"
        // ? "DD-MM-YYYY"
        // : 
        "DD-MM-YYYY HH:mm",
      )
      }`,
      "To",
      `${document.getElementById("filled-full-width") &&
      moment(document.getElementById("filled-full-width").value).format(
        // report === "dailyDistance" || report === "summary"
        // ? "DD-MM-YYYY"
        // : 
        "DD-MM-YYYY HH:mm",
      )
      }`,
    ];

    setExportHeading(exportHeadings);

    if (window.location.pathname.split("/")[1] == "Summary") {
      if (!deviceId && selectedStoppageVehicles.length === 0) {
        if (Object.keys(sourceId).length == 0) {
          alert("Please Select vehicle.");
          return false;
        } else {
          localStorage.removeItem("vehicle");
        }
      }
    } else {
      if (!deviceId && selectedStoppageVehicles.length === 0) {
        alert("Please Select Vehicle");
        return false;
      }
    }

    let selectedFrom;
    let selectedTo;
    switch (period) {
      case "today1":
        selectedFrom = moment().startOf("day");
        selectedTo = moment().endOf("day");
        setFrom(selectedFrom);
        setTo(selectedTo);

        break;
      case "yesterda1":
        selectedFrom = moment().subtract(1, "day").startOf("day");
        selectedTo = moment().subtract(1, "day").endOf("day");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "thisWeek1":
        selectedFrom = moment().startOf("week");
        selectedTo = moment().endOf("week");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "previousWeek1":
        selectedFrom = moment().subtract(1, "week").startOf("week");
        selectedTo = moment().subtract(1, "week").endOf("week");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "thisMonth1":
        selectedFrom = moment().startOf("month");
        selectedTo = moment().endOf("month");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      case "previousMonth1":
        selectedFrom = moment().subtract(1, "month").startOf("month");
        selectedTo = moment().subtract(1, "month").endOf("month");
        setFrom(selectedFrom);
        setTo(selectedTo);
        break;
      default:
        selectedFrom = from;
        selectedTo = to;
        break;
    }

    console.log(Date.parse(selectedFrom));
    console.log(selectedTo);
    if (
      JSON.parse(localStorage.getItem("data")) &&
      (JSON.parse(localStorage.getItem("data")).dateFilterLimit == 0 ||
        JSON.parse(localStorage.getItem("data")).dateFilterLimit == null)
    ) {
      const fromDate = moment(selectedFrom);
      const toDate = moment(selectedTo);
      if (
        // Date.parse(selectedTo) - Date.parse(selectedFrom) >
        // 365 * 1000 * 60 * 60 * 24
        toDate.diff(fromDate, "months", true) > 1
      ) {
        alert(
          // `Date difference should in ${
          //   JSON.parse(localStorage.getItem("data")).dateFilterLimit
          // } days Max`
          // `Date difference should in 2 days Max`,
          "Date difference should not be more than 1 month",
        );
        return false;
      }
    } else if (
      JSON.parse(localStorage.getItem("data")) &&
      (JSON.parse(localStorage.getItem("data")).dateFilterLimit != 0 ||
        JSON.parse(localStorage.getItem("data")).dateFilterLimit != null)
    ) {
      if (
        Date.parse(selectedTo) - Date.parse(selectedFrom) >
        2 * 1000 * 60 * 60 * 24
      ) {
        alert(
          `Date difference should in ${JSON.parse(localStorage.getItem("data")).dateFilterLimit
          } days Max`,
        );
        return false;
      }
    }

    const accept = json
      ? "application/json"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    handleSubmit(
      deviceId
        ? deviceId.gpsRefId
        : selectedStoppageVehicles.length > 0
          ? selectedStoppageVehicles
          : vehicleList,
      selectedFrom.toISOString(),
      selectedTo.toISOString(),
      mail,
      { Accept: accept },
    );
  };

  // const getVendorId = (data) => {
  //   if (data != null) {
  //     setVendorId({ id: data.id });
  //     if (vehicleList.length > 0) {
  //       filterVehicleLIst(vehicleList, data.id, "vendor", true);
  //     } else {
  //       filterVehicleLIst(vehicleListOld, data.id, "vendor", true);
  //     }
  //     // filterByReference(vehicleList,userlist,data.id)
  //   } else {
  //     setVendorId({});

  //     if (Object.keys(sourceId).length > 0) {
  //       filterVehicleLIst(vehicleListOld, sourceId.id, "site", false);
  //     } else if (Object.keys(routeId).length > 0) {
  //       filterVehicleLIst(vehicleListOld, routeIdParent.id, "site", false);
  //     } else {
  //       setVehicleList(vehicleListOld);
  //     }
  //   }
  // };

  // const getSourceId = (data) => {
  //   if (data != null) {
  //     setSourceId({ id: data.id });
  //     localStorage.setItem("source", JSON.stringify(data));

  //     if (vehicleList.length > 0) {
  //       filterVehicleLIst(vehicleList, data.id, "site", true);
  //     } else {
  //       filterVehicleLIst(vehicleListOld, data.id, "site", true);
  //     }
  //   } else {
  //     setSourceId({});
  //     localStorage.removeItem("source");
  //     if (Object.keys(vendorId).length > 0) {
  //       filterVehicleLIst(vehicleListOld, vendorId.id, "vendor", false);
  //     } else if (Object.keys(routeId).length > 0) {
  //       filterVehicleLIst(vehicleListOld, routeIdParent.id, "site", false);
  //     } else {
  //       setVehicleList(vehicleListOld);
  //     }
  //   }
  // };
  function toTimestamp(strDate) {
    return Date.parse(strDate);
  }
  const filterVehicleLIst = (vehicleArray, id, type, checkVendorSite) => {
    console.log(id, type);
    let res = [];
    console.log(vehicleArray);
    switch (type) {
      case "vendor":
        res = vehicleArray.filter((el) => {
          if (checkVendorSite && Object.keys(sourceId).length > 0) {
            return (
              el.vendor &&
              el.vendor.id == id &&
              el.site &&
              el.site.id == sourceId.id
            );
          } else {
            return el.vendor && el.vendor.id == id;
          }
        });
        break;
      case "site":
        res = vehicleArray.filter((el) => {
          if (checkVendorSite && Object.keys(vendorId).length > 0) {
            return (
              el.site &&
              el.site.id == id &&
              el.vendor &&
              el.vendor.id == vendorId.id
            );
          } else {
            return el.site && el.site.id == id;
          }
        });
        break;
      default:
        break;
    }

    console.log(res);
    setVehicleList(res);
  };

  const getDisplayTitle = (name) => {
    if (!name) return "";
    let cleanName = name;
    if (cleanName.toLowerCase().endsWith("report")) {
      cleanName = cleanName.slice(0, -6);
    }
    const spaced = cleanName
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
    return `${spaced} Report`;
  };

  const TopViewData = {
    title: getDisplayTitle(
      window.location.pathname.split("/")[1] == "reportsgps"
        ? report
        : window.location.pathname == "/Summary"
          ? "Travel Summary"
          : window.location.pathname.split("/")[1],
    ),
    subTitleFirst: "Dashboard >",
    subTitleSecond: "Reports >",
    subTitleThird: getDisplayTitle(
      window.location.pathname.split("/")[1] == "reportsgps"
        ? report
        : window.location.pathname.split("/")[1],
    ),
  };

  const handleNewExport = async (type) => {
    if (!exportData || exportData.length === 0) {
      alert("No data to export");
      return;
    }
    const stored = JSON.parse(localStorage.getItem("data"));
    const sideIds = (stored.sites || []).map((s) => s.id);
    const effectiveReport = reportType || report;
    const rpn = effectiveReport.toUpperCase();
    console.log("reportType", rpn);
    let pageParam = "";
    if (rpn === "STOP" || rpn === "STOPREPORT" || rpn === "STOPPAGE")
      pageParam = "STOPPAGE_REPORT";
    else if (rpn === "IDLE" || rpn === "IDLEREPORT")
      pageParam = "IDLE_REPORT";
    else if (rpn === "DAILYDISTANCE") pageParam = "SUMMARY_REPORT";
    else if (
      rpn === "TRAVEL SUMMARY" ||
      rpn === "TRAVELSUMMARY" ||
      rpn === "SUMMARY"
    )
      pageParam = "SUMMARY_REPORT";
    else if (rpn === "TRIP" || rpn === "TRIPREPORT") pageParam = "TRIP_REPORT";
    else pageParam = rpn;

    const isViewPage = rpn === "DAILYDISTANCE" || rpn === "SUMMARY";

    const payload = {
      companyId: stored.companyId,
      fromDate: from.valueOf(),
      toDate: to.valueOf(),
      isViewPage,
      isExcelReport: type === "excel",
      vendors: Object.keys(vendorId).length > 0 ? [vendorId] : [],
      sourceSite: Object.keys(sourceId).length > 0 ? [sourceId] : [],
      vehicles:
        //  selectedStoppageVehicleIds.length > 0
        //     ? selectedStoppageVehicleIds.map((id) => ({ gpsRefId: id }))
        selectedStoppageVehicles.length > 0
          ? selectedStoppageVehicles.map((v) => ({
            ...(v.gpsRefId != null && v.gpsRefId !== "" ? { gpsRefId: v.gpsRefId } : {}),
            ...(v.id != null && v.id !== "" ? { id: v.id } : {}),
          }))
          : deviceId && Object.keys(deviceId).length > 0
            ? [deviceId]
            : [],
      sideIds,
      userId: stored.id,
      ...(selectedStoppageVehicleIds.length > 0
        ? { deviceIds: selectedStoppageVehicleIds }
        : {}),
      ...(selectedStoppageVehicleEntityIds.length > 0
        ? { vehicleIds: selectedStoppageVehicleEntityIds }
        : {}),
    };

    setLoading(true);
    try {
      const token = localStorage.getItem("token") || stored.token;
      const baseUrl = JSON.parse(localStorage.getItem("config")).baseUrl;
      const response = await fetch(
        `${baseUrl}api/v1/exports/reports/page/data?page=${pageParam}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseText = await response.text();
      let base64 = "";

      try {
        const json = JSON.parse(responseText);
        base64 = json?.data || json?.fileData || json?.base64 || json;
      } catch (e) {
        base64 = responseText;
      }

      if (typeof base64 !== "string" || base64.length < 10) {
        alert("Export failed: invalid file data received");
        return;
      }

      // Clean the base64 string: remove data URL prefix if present and strip all whitespace
      base64 = base64.replace(/^data:.*,/, "").replace(/\s/g, "");

      const mimeType =
        type === "excel"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "application/pdf";
      const ext = type === "excel" ? "xlsx" : "pdf";

      try {
        const byteChars = atob(base64);
        const byteArr = new Uint8Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++)
          byteArr[i] = byteChars.charCodeAt(i);
        const blob = new Blob([byteArr], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${effectiveReport.toUpperCase()}_Report_${moment().format("YYYY-MM-DD_HH-mm")}.${ext}`;
        a.click();
        URL.revokeObjectURL(url);
      } catch (atobErr) {
        console.error("Base64 decoding error:", atobErr);
        alert("Export failed: could not decode file data.");
      }
    } catch (err) {
      console.error("Export error:", err);
      alert("Export failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <LoadingComponent isLoading={loading} />
      {/* {window.location.pathname.split("/")[1] == "reportsgps" && (
        <Grid container spacing={12} className="mt-2">
          <Grid item md={12} className={classes.formControl}>
            {window.location.pathname.split("/")[1] != "reportsgps" ? (
              ""
            ) : (
              <div style={{ marginBottom: "-15px" }}>
                <Button
                  variant="outlined"
                  className="mx-2 btn bg-transparent"
                  style={{
                    border: report == "stop" ? "1px solid #5F3B8F" : "",
                    color: report == "stop" ? " #5F3B8F" : "",
                  }}
                  onClick={(e) => newReport("stop")}
                >
                  {" "}
                  Stop Report
                </Button>
                <Button
                  variant="outlined"
                  className="mx-2 btn "
                  style={{
                    border:
                      report == "dailyDistance" ? "1px solid #5F3B8F" : "",
                    color: report == "dailyDistance" ? " #5F3B8F" : "",
                  }}
                  onClick={(e) => newReport("dailyDistance")}
                >
                  {" "}
                  Daily Distance Report
                </Button>
                <Button
                  variant="outlined"
                  className="mx-2 btn "
                  style={{
                    border: report == "summary" ? "1px solid #5F3B8F" : "",
                    color: report == "summary" ? " #5F3B8F" : "",
                  }}
                  onClick={(e) => newReport("summary")}
                >
                  {" "}
                  Summary Report
                </Button>
                <Button
                  variant="outlined"
                  className="mx-2 btn "
                  style={{
                    border: report == "trip" ? "1px solid #5F3B8F" : "",
                    color: report == "trip" ? " #5F3B8F" : "",
                  }}
                  onClick={(e) => newReport("trip")}
                >
                  {" "}
                  Trip Report
                </Button>
                <Button
                  variant="outlined"
                  className="mx-2 btn "
                  style={{
                    border: report == "event" ? "1px solid #5F3B8F" : "",
                    color: report == "event" ? " #5F3B8F" : "",
                  }}
                  onClick={(e) => newReport("event")}
                >
                  {" "}
                  Event Report
                </Button>
              </div>
            )}
          </Grid>
        </Grid>
      )} */}

      <Grid
        container
        spacing={12}
        alignItems="center"
        style={{
          marginBottom: "-30px",
          paddingRight: "13px",
        }}
      >
        {/* <Grid item xs={12} md={2} lg={2} className={classes.formControl}>
          <FormControl variant="filled" margin="normal" fullWidth >

          <Typography className="font14 greyfirstheading"  gutterBottom variant="subtitle1">
               Select Report *
                </Typography>
               
        <Select  value={report} onChange={(e) => newReport(e.target.value)}  className='select_type'>
          <MenuItem value="movement">Movement Report</MenuItem>
          <MenuItem value="summary">Summary Report</MenuItem>
          <MenuItem value="stop">Stop Report</MenuItem>
          <MenuItem value="trip">Trip Report</MenuItem>
          <MenuItem value="route">Route Report</MenuItem>
          <MenuItem value="event">Event Report</MenuItem>

         
        </Select>
      </FormControl>
      
          </Grid> */}

        <Grid
          item
          container
          md={4}
          justify="flex-start"
          alignItems="center"
          style={{ marginTop: "30px", marginBottom: "20px" }}
        >
          <KeyboardBackspaceIcon
            style={Styles.backIcon}
          //   onClick={(event)=>routePath(data.backPathSecond)}
          />
          <span style={Styles.spanContainer}>
            <Typography variant="h6" style={{ fontWeight: 600 }} >
              {TopViewData.title}
            </Typography>
            {/* <p style={Styles.p}>
              <span
                // onClick={(event)=>routePath(data.backPath)}
                className="cousor_pointer"
              >
                {TopViewData.subTitleFirst}{" "}
              </span>
              <span style={Styles.addSiteText}>
                {TopViewData.subTitleThird}
              </span>
            </p> */}
          </span>
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
          lg={8}
          className={classes.formControl}
          style={{
            marginTop: "30px",
            marginBottom: "20px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {showToggle && (
              <ModeToggle
                value={trackingMode}
                onChange={setTrackingMode}
                options={[
                  { value: "gps", label: "GPS Report", iconActive: GpsWhite, iconInactive: GpsBlue },
                  { value: "digitalLock", label: "Lock Report", iconActive: LockWhite, iconInactive: LockBlue },
                ]}
              />
            )}
            <InfoMessage />

            {
              (window.location.pathname !== "/fuelSummaryReport" && window.location.pathname !== "/fuelFillReport" &&
                window.location.pathname !== "/fuelDroppageReport"
              ) &&
              <Button
                color="primary"
                variant="contained"
                style={{
                  borderRadius: 10,
                  height: 36,
                  minWidth: 80,
                  background: "#082D6B",
                }}
                onClick={() => setOldReport(true)}
              >
                Request Report
              </Button>
            }
          </Box>
        </Grid>

        {/* <Grid item xs={12} md={2} lg={2} className={classes.formControl}></Grid> */}

        {/* <Grid item xs={12} md={2} lg={2} className={classes.formControl}> */}
        {/* <FormControl
            variant="filled"
            margin="normal"
            fullWidth
            className="mx-2"
          >
            <Typography
              className="font14 greyfirstheading"
              gutterBottom
              variant="subtitle1"
              style={{ visibility: "hidden" }}
            >
              Select Transporter*
            </Typography>
            <Typography variant="body2" gutterBottom>
              <Autocomplete
                style={{ backgroundColor: "white" }}
                id="header"
                getOptionLabel={(vendorList) => vendorList.name}
                className="user"
                options={vendorList || []}
                disablePortal={true}
                onChange={(event, newValue) => getVendorId(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Select Transporter"
                  />
                )}
              />
            </Typography>
          </FormControl> */}
        {/* </Grid> */}

        {/* <Grid item xs={12} md={2} lg={2} className={classes.formControl}> */}
        {/* <FormControl
            variant="filled"
            margin="normal"
            fullWidth
            className="mx-2"
          >
            <Typography
              className="font14 greyfirstheading"
              gutterBottom
              variant="subtitle1"
              style={{ visibility: "hidden" }}
            >
              Select Transporter*
            </Typography>
            <Typography variant="body2" gutterBottom>
              <Autocomplete
                style={{ backgroundColor: "white" }}
                id="header"
                getOptionLabel={(vendorList) => vendorList.name}
                className="user"
                options={vendorList || []}
                disablePortal={true}
                onChange={(event, newValue) => getVendorId(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Select Transporter"
                  />
                )}
              />
            </Typography>
          </FormControl> */}
        {/* <FormControl
            variant="filled"
            margin="normal"
            fullWidth
            className="mx-2"
          >
            <Typography
              className="font14 greyfirstheading"
              gutterBottom
              variant="subtitle1"
              style={{ visibility: "hidden" }}
            >
              Select Vehicle *
            </Typography>
            <Typography variant="body2" gutterBottom>
              <Autocomplete
                style={{ backgroundColor: "white" }}
                getOptionLabel={(option) => option.name}
                className="user"
                options={siteList || []}
                filterSelectedOptions
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
                disablePortal={true}
                onChange={(event, newValue) => getSourceId(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Select Site"
                  />
                )}
              />
            </Typography>
          </FormControl> */}
      </Grid>
      <Paper className="sub-user-list-paper-report">
        <div
          className="sl-toolbar"
          style={{
            flexWrap: "wrap",
            padding: "10px 20px",
            gap: 8,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <div className="sl-toolbar-left" style={{ flexWrap: "wrap", gap: 8 }}>
            {/* Quick dates */}
            {/* <Button
              variant="outlined"
              size="small"
              style={{
                borderColor: "#d1d5db",
                height: 40,
                width: 80,
                backgroundColor: "white",
                borderRadius: 10,
              }}
              onClick={() => setDateToFrom("today")}
            >
              Today
            </Button>
            <Button
              variant="outlined"
              size="small"
              style={{
                borderColor: "#d1d5db",
                height: 40,
                width: 80,
                backgroundColor: "white",
                borderRadius: 10,
              }}
              onClick={() => setDateToFrom("yesterday")}
            >
              Yesterday
            </Button> */}

            <MuiAutocomplete
              size="small"
              options={datePresetOptions}
              value={datePreset}
              getOptionLabel={(option) => option.label}
              onChange={(e, newValue) => {
                if (newValue) handleDatePresetChange(newValue);
              }}
              sx={{ width: 160 }}
              renderInput={(params) => (
                <MuiTextField
                  {...params}
                  placeholder="Today"
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 40,
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      fontSize: 13,
                      "& fieldset": {
                        borderColor: "#d1d5db",
                      },
                      "&:hover fieldset": {
                        borderColor: "#9ca3af",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#2563eb",
                      },
                    },
                  }}
                />
              )}
            />
            {/* From / To date inputs */}
            <div className="gf-search-wrap">
              <input
                id="datetime-local"
                className="gf-search-input"
                type={
                  // report === "dailyDistance" || report === "summary"
                  // ? "date"
                  // :
                  "datetime-local"
                }
                min={
                  // report === "dailyDistance" || report === "summary"
                  // ? reportsMinDateFormatted.split("T")[0]
                  // : 
                  reportsMinDateFormatted
                }
                max={
                  // report === "dailyDistance" || report === "summary"
                  // ? moment().format("YYYY-MM-DD")
                  // : 
                  moment().format(moment.HTML5_FMT.DATETIME_LOCAL)
                }
                value={
                  // report === "dailyDistance" || report === "summary"
                  // ? from.format("YYYY-MM-DD")
                  // : 
                  from.format(moment.HTML5_FMT.DATETIME_LOCAL)
                }
                onChange={(e) => {
                  const val = e.target.value;
                  const newDate =
                    // report === "dailyDistance" || report === "summary"
                    // ? moment(val).startOf("day")
                    // : 
                    moment(val, moment.HTML5_FMT.DATETIME_LOCAL);
                  setFrom(newDate);
                  if (newDate.isAfter(to)) {
                    setTo(
                      // report === "dailyDistance" || report === "summary"
                      // ? newDate.clone().endOf("day")
                      // : 
                      newDate.clone().add(1, "hour"),
                    );
                  }
                }}
              // style={{ width: 190 }}
              />
            </div>
            <div className="gf-search-wrap">
              <input
                id="filled-full-width"
                className="gf-search-input"
                type={
                  // report === "dailyDistance" || report === "summary"
                  // ? "date"
                  // :
                  "datetime-local"
                }
                // min={
                //   report === "dailyDistance" || report === "summary"
                //     ? from.format("YYYY-MM-DD")
                //     : from.isAfter(reportsMinDate)
                //       ? from.format(moment.HTML5_FMT.DATETIME_LOCAL)
                //       : reportsMinDateFormatted
                // }
                min={
                  from.isAfter(reportsMinDate)
                    ? from.format(moment.HTML5_FMT.DATETIME_LOCAL)
                    : reportsMinDateFormatted
                }
                max={
                  // report === "dailyDistance" || report === "summary"
                  // ? moment().format("YYYY-MM-DD")
                  // : 
                  moment().format(moment.HTML5_FMT.DATETIME_LOCAL)
                }
                value={
                  // report === "dailyDistance" || report === "summary"
                  // ? to.format("YYYY-MM-DD")
                  // :
                  to.format(moment.HTML5_FMT.DATETIME_LOCAL)
                }
                onChange={(e) => {
                  const val = e.target.value;
                  const newDate =
                    // report === "dailyDistance" || report === "summary"
                    // ? moment(val).endOf("day")
                    // : 
                    moment(val, moment.HTML5_FMT.DATETIME_LOCAL);
                  setTo(newDate);
                }}
              />
            </div>
            {/* ======================================================NIKHIL CHANGES STARTS HERE============================================ */}

            <MuiAutocomplete
              multiple
              size="small"
              disableCloseOnSelect
              limitTags={1}
              options={sortedStoppageVehicleList}
              value={selectedStoppageVehicles}
              isOptionEqualToValue={(o, v) => o.id === v.id}
              getOptionLabel={(o) => o.number || ""}
              filterOptions={
                trackingMode === "digitalLock" ? lockFilterOptions : vehicleFilterOptions
              }
              onOpen={() => {
                setStoppageSortSelectedIds(
                  new Set(selectedStoppageVehicles.map((v) => v.id)),
                );
              }}
              getOptionDisabled={(o) =>
                !selectedStoppageVehicles.some((s) => s.id === o.id) &&
                // selectedStoppageVehicles.length >= MAX_STOPPAGE_VEHICLE_SELECT
                selectedStoppageVehicles.length >= effectiveMaxVehicles
              }
              onChange={(_, newVal) =>
                setSelectedStoppageVehicles(
                  // newVal.slice(0, MAX_STOPPAGE_VEHICLE_SELECT),
                  newVal.slice(0, effectiveMaxVehicles),
                )
              }
              ListboxComponent={StpListboxComponent}
              ListboxProps={{
                style: {
                  padding: 0,
                  maxHeight: "none",
                  overflow: "hidden",
                },
              }}
              PaperComponent={useMemo(
                () =>
                  forwardRef((props, ref) => (
                    <StpVehiclePaper
                      {...props}
                      ref={ref}
                      stpVehicleFilterType={stpVehicleFilterType}
                      setStpVehicleFilterType={setStpVehicleFilterType}
                      // MAX_STOPPAGE_VEHICLE_SELECT={MAX_STOPPAGE_VEHICLE_SELECT}
                      MAX_STOPPAGE_VEHICLE_SELECT={effectiveMaxVehicles}
                      isToDateToday={isToDateToday}
                      trackingMode={trackingMode}
                    />
                  )),
                [
                  stpVehicleFilterType,
                  setStpVehicleFilterType,
                  // MAX_STOPPAGE_VEHICLE_SELECT,
                  effectiveMaxVehicles,
                  isToDateToday,
                  trackingMode,
                ],
              )}
              renderTags={(tagVal, getTagProps) =>
                tagVal.length === 1 ? (
                  <Chip
                    label={tagVal[0].number}
                    size="small"
                    {...getTagProps({ index: 0 })}
                    sx={{ maxWidth: 90, fontSize: 11 }}
                  />
                ) : (
                  <span style={{ fontSize: 12, color: "#374151" }}>
                    {tagVal.length} {trackingMode === "digitalLock" ? "locks" : "vehicles"}
                  </span>
                )
              }
              renderOption={(props, option, { index }) => {
                const isLockMode = trackingMode === "digitalLock";

                const cfg = isLockMode
                  ? getLockStatusCfg(option)
                  : statusColors[option?.runningStatus?.toUpperCase()] || statusColors.OFFLINE;

                const isSelected = selectedStoppageVehicles.some((s) => s.id === option.id);

                return (
                  <li
                    {...props}
                    style={{
                      ...props.style,
                      padding: 0,
                      margin: 0,
                      listStyle: "none",
                      height: STP_ROW_HEIGHT,
                    }}
                  >
                    <OptionWrapper
                      index={index}
                      sx={{
                        "&:hover": { backgroundColor: cfg.bg },
                        backgroundColor: isSelected ? `${cfg.bg}80` : "transparent",
                      }}
                    >
                      <input
                        type="checkbox"
                        readOnly
                        checked={isSelected}
                        style={{
                          accentColor: cfg.color,
                          width: 14,
                          height: 14,
                          marginRight: 10,
                          cursor: "pointer",
                        }}
                      />

                      {isLockMode ? (
                        <span style={{ fontSize: 12, marginRight: 8, flexShrink: 0 }}>{cfg.icon}</span>
                      ) : (
                        <StatusIndicator status={option?.runningStatus?.toUpperCase() || "OFFLINE"} />
                      )}

                      <Box
                        component="span"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontWeight: isSelected ? 600 : 500,
                            color: "hsl(222.2,84%,4.9%)",
                            fontSize: 13,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {option.number}
                        </Box>



                        {isLockMode && option.vehicleNo && (
                          <Box
                            component="span"
                            sx={{
                              fontSize: 11,
                              color: "#6b7280",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            Vehicle: {option.vehicleNo}
                          </Box>
                        )}
                        {!isLockMode && option.imeiNo && (
                          <Box component="span" sx={{ fontSize: 11, color: "#6b7280", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            IMEI: {option.imeiNo}
                          </Box>
                        )}
                      </Box>

                      <StatusBadge
                        status={isLockMode ? undefined : option?.runningStatus?.toUpperCase() || "OFFLINE"}
                        style={
                          isLockMode
                            ? { backgroundColor: cfg.bg, color: cfg.color, marginLeft: "auto" }
                            : undefined
                        }
                      >
                        {cfg.label}
                      </StatusBadge>
                    </OptionWrapper>

                  </li>
                );
              }}
              sx={{ width: 280 }}
              renderInput={(params) => (
                <MuiTextField
                  {...params}
                  variant="outlined"
                  placeholder={
                    trackingMode === "digitalLock"
                      ? "Choose Lock"
                      : "Choose Vehicles"
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      minHeight: "40px",
                      borderRadius: "10px",
                      bgcolor: "#fff",
                      padding: "4px 8px !important",
                      fontSize: 13,
                      "& fieldset": { borderColor: "#d1d5db" },
                      "&:hover fieldset": { borderColor: "#9ca3af" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#2563eb",
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "0 4px !important",
                      fontSize: 13,
                    },
                  }}
                />
              )}
            />
            {/* ======================================================NIKHIL CHANGES ENDS HERE============================================ */}
            <Button
              color="primary"
              variant="contained"
              style={{
                borderRadius: 10,
                height: 36,
                minWidth: 80,
                background: "#082D6B",
              }}
              onClick={() => handleClick(false, true)}
            >
              {t("reportShow")}
            </Button>
          </div>

          <div
            className="sl-toolbar-right"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ display: "flex", gap: 8 }}>
              {/* <Button
                color="primary"
                variant="contained"
                className="sl-btn-export"
                onClick={() => handleNewExport("excel")}
                title="Export Excel"
                disabled={loading}
                style={{ display: "flex", alignItems: "center", gap: 8 }}
              >
                Export Excel{" "}
                <FaFileExcel
                  style={{ fontSize: 18, color: "#2e7d32", marginLeft: 6 }}
                />
              </Button>
              <Button
                color="primary"
                variant="contained"
                className="sl-btn-export"
                onClick={() => handleNewExport("pdf")}
                title="Export PDF"
                disabled={loading}
                style={{ display: "flex", alignItems: "center", gap: 8 }}
              >
                Export Pdf{" "}
                <FaFilePdf
                  style={{ fontSize: 18, color: "#d32f2f", marginLeft: 6 }}
                />
              </Button> */}
              <Button
                variant="contained"
                startIcon={<FaFileExcel style={{ fontSize: 18 }} />}
                endIcon={<DownloadIcon />}
                onClick={() => handleNewExport("excel")}
                disabled={loading}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  height: 40,
                  padding: "0 18px",
                  background:
                    "linear-gradient(135deg, #064e3b 0%, #065f46 30%, #047857 60%, #059669 100%)",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: 10,
                  fontSize: 14,
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0 4px 16px rgba(6, 78, 59, 0.45)",
                  whiteSpace: "nowrap",
                  letterSpacing: "0.3px",
                }}
              >
                Excel
              </Button>
              <Button
                variant="contained"
                startIcon={<BsFileEarmarkPdfFill style={{ fontSize: 18 }} />}
                onClick={() => handleNewExport("pdf")}
                disabled={loading}
                endIcon={<DownloadIcon />}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  height: 40,
                  padding: "0 18px",
                  background:
                    "linear-gradient(135deg, #7f1d1d 0%, #991b1b 30%, #b91c1c 60%, #dc2626 100%)",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: 10,
                  fontSize: 14,
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0 4px 16px rgba(127, 29, 29, 0.45)",
                  whiteSpace: "nowrap",
                  letterSpacing: "0.3px",
                }}
              >
                PDF
              </Button>

            </div>
            {extraActions}
          </div>
        </div>
      </Paper>
      <OldReportRequestDialog
        row={oldReport}
        reportsMinDate={reportsMinDate}
        stoppageVehicleList={activeDeviceList}
        MAX_STOPPAGE_VEHICLE_SELECT={MAX_STOPPAGE_VEHICLE_SELECT}
        reportType={reportType}
        report={report}
        onClose={() => setOldReport(false)}
        trackingMode={trackingMode}
      />
      {children}
    </>
  );
};

export default ReportFilter;
{
  /* <FormControl margin="normal" fullWidth>
<ButtonGroup  orientation="vertical" disabled={!deviceId}>
  <Button onClick={() => handleClick(false, true)}>{t('reportShow')}</Button>
  {!showOnly && <Button onClick={() => handleClick(false, false)}>{t('reportExport')}</Button>}
  {!showOnly && <Button onClick={() => handleClick(true, false)}>{t('reportEmail')}</Button>}
</ButtonGroup>
</FormControl> */
}
